import * as actions from '../redux/actions';

import { KuposCheckbox, PaymentOptions } from '../../../common';

import BookingInput from '../BookingInput/BookingInput';
import CommonService from '../../../../services/commonService';
import ContactInputTable from '../ContactInputTable/ContactInputTable';
import LoginBlock from '../LoginBlock/LoginBlock';
import PaymentRightSideBar from '../PaymentRightSideBar/PaymentRightSideBar';
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

const PaymentMain = props => {
  const { t, pbServiceList, pbPaymentDetails, home } = props;

  // console.log({ props })
  return (
    <div className="pb-payment-details-payment-main">
      <div className="pb-service-list-payment-details-page content-container flex-row passenger-and-payment-details-container">
        <div className="passenger-input-container">
          {!CommonService.isLoggedIn() ? <LoginBlock t={t} /> : null}
          <div className="kupos-card passenger-input-details">
            <div className="flex-row passenger-details-title-row">
              <div className="font13">
                {t('PASSENGER_DETAILS.PASSENGER_DETAIL.NORMAL')}
                <span className="bold font13">{t('PASSENGER_DETAILS.PASSENGER_DETAIL.BOLD')}</span>
              </div>

              <div
                className="primary-text bold-text countdown-counter font13"
                style={{ position: 'relative' }}
              >
                {props.timeInfoHover ? (
                  <span
                    className="info-popup font10 normal-text"
                    style={
                      Number(props.countdown.split(':')[0]) < 3
                        ? {
                            top: -16,
                            right: 110,
                            width: '400%',
                            color: '#464647',
                            textAlign: 'center',
                          }
                        : {
                            top: -4,
                            right: 110,
                            width: '400%',
                            color: '#464647',
                            textAlign: 'center',
                          }
                    }
                  >
                    {Number(props.countdown.split(':')[0]) < 3
                      ? t('PROFILE.TIME_LEFT_LESS_THREE')
                      : t('PROFILE.TIME_LEFT_TO_PURCHASE')}
                  </span>
                ) : null}
                <img
                  onMouseEnter={props.setTimeInfoHover}
                  onMouseLeave={props.setTimeInfoHover}
                  src="/images/icons/icon-chronometer.png"
                  className="clock-over"
                  alt="clock-over"
                />

                {/* {console.log('Countdown is now:', Number(countdown.split(':')[0]))} */}
                <span>{props.countdown}</span>
              </div>
            </div>
            <div className="passenger-inputs-block">
              <span className="bold journey-type-title font10">{t('PASSENGER_DETAILS.GOING')}</span>
            </div>

            {pbServiceList &&
            pbServiceList.bookingDetailsOnward &&
            pbServiceList.bookingDetailsOnward.selectedSeatsToBook ? (
              <BookingInput
                selectedSeatsToBook={pbServiceList.bookingDetailsOnward.selectedSeatsToBook}
                idCardTypes={props.idCardTypes}
                countries={props.countries}
                passengerDetails={pbPaymentDetails.passengerDetailsOnward}
                onNameChange={(text, seat) => props.onNameChange(text, seat)}
                onLastNameChange={(text, seat) => props.onLastNameChange(text, seat)}
                onCountryChange={(val, seat) => props.onCountryChange(val, seat)}
                onIdCardChange={(label, seat) => props.onIdCardChange(label, seat)}
                onIdCardNumberChange={(text, seat) => props.onIdCardNumberChange(text, seat)}
                onInputBlur={(text, seat, inp) => props.onInputBlur(text, seat, inp)}
                nameError={props.nameError}
                last_nameError={props.last_nameError}
                cardNumberError={props.cardNumberError}
                seatsTitle="DATOS DEL PASAJERO (IDA)"
                t={t}
              />
            ) : null}

            {home.returnPBDate &&
            pbServiceList.bookingDetailsReturn &&
            pbServiceList.bookingDetailsReturn.selectedSeatsToBook ? (
              <div>
                <div className="passenger-inputs-block flex-row">
                  <span className="bold journey-type-title font10">
                    {t('RESULTS_PAGE.RETURN')}{' '}
                  </span>
                  <span className="font10">
                    <KuposCheckbox
                      checked={props.copyToReturnChecked}
                      onChange={props.copyToReturn}
                      label={t('PASSENGER_DETAILS.APPLY_SAME_PASSENGER_DETAILS_FOR_GOING_TRIP')}
                    />{' '}
                  </span>
                </div>
                <BookingInput
                  selectedSeatsToBook={pbServiceList.bookingDetailsReturn.selectedSeatsToBook}
                  idCardTypes={props.idCardTypes}
                  countries={props.countries}
                  passengerDetails={pbPaymentDetails.passengerDetailsReturn}
                  onNameChange={(text, seat) => props.onNameChangeReturn(text, seat)}
                  onLastNameChange={(text, seat) => props.onLastNameChangeReturn(text, seat)}
                  onCountryChange={(val, seat) => props.onCountryChangeReturn(val, seat)}
                  onIdCardChange={(val, seat) => props.onIdCardChangeReturn(val, seat)}
                  onIdCardNumberChange={(text, seat) =>
                    props.onIdCardNumberChangeReturn(text, seat)
                  }
                  onInputBlur={props.onInputBlurReturn}
                  nameError={props.nameReturnError}
                  last_nameError={props.last_nameReturnError}
                  cardNumberError={props.cardNumberReturnError}
                  seatsTitle="DATOS DEL PASAJERO (VUELTA)"
                  t={t}
                />
              </div>
            ) : null}

            <ContactInputTable
              t={t}
              emailError={props.mobileError}
              confirmEmailError={props.confirmEmailError}
              mobileError={props.mobileError}
              onInputChange={props.onInputChange}
              onInputBlurContact={props.onInputBlurContact}
            />
          </div>

          <PaymentOptions
            paymentGatewayList={props.paymentGatewayList}
            selected={props.selected}
            onPaymentSelect={props.onPaymentSelect}
            walletChecked={props.walletChecked}
            virtualChecked={props.virtualChecked}
            walletMoney={props.walletMoney}
            virtualMoney={props.virtualMoney}
            isLoggedIn={props.isLoggedIn}
            checkWallet={props.checkWallet}
            checkVirtual={props.checkVirtual}
            onPay={props.onPay}
            bookTicketPending={props.bookTicketPending}
            bookingError={props.bookingError}
            onBookingErrorClick={props.onBookingErrorClick}
            onPromoCheckboxChange={props.onPromoCheckboxChange}
            promoCodeChecked={props.promoCodeChecked}
            onPromoCodeChange={props.onPromoCodeChange}
            onPromoCodeBlur={props.onPromoCodeBlur}
            applyPromoCodePending={props.applyPromoCodePending}
            onApplyPromoCode={props.onApplyPromoCode}
            promoCodeError={props.promoCodeError}
            t={t}
            history={props.history}
            tncChecked={props.tncChecked}
            onTncChange={props.onTncChange}
            totalAmount={props.totalAmount}
            showKuposPay={true}
            showPaypal={true}
            showPromocode={true}
            showBancoEstado={true}
            corporateDiscountState={props.corporateDiscountState}
          />
        </div>
        <PaymentRightSideBar
          t={t}
          wallet={props.wallet}
          virtual={props.virtual}
          walletMoneyAdded={props.walletMoneyAdded}
          virtualMoneyAmount={props.virtualMoneyAmount}
          basicFare={props.basicFare}
          calculateNetFare={props.calculateNetFare}
          calculateNetFareUSD={props.calculateNetFareUSD}
          promoCode={props.promoCode}
          onPromoRemove={props.onPromoRemove}
          promoCouponAmount={props.promoCouponAmount}
          showUsd={props.showUsd}
          corporateDiscountState={props.corporateDiscountState}
          test={'test'}
        />
      </div>
    </div>
  );
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    pbPaymentDetails: state.pbPaymentDetails,
    pbServiceList: state.pbServiceList,
    home: state.home,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PaymentMain);



// WEBPACK FOOTER //
// ./src/features/Pasajebus/PasajebusPaymentDetails/PaymentMain/PaymentMain.js